import React from 'react';
import serviceimg from '../../src/images/service/imgsm.png';

const Testimonials = ({ header }) => {
  return (
    <section className="flex flex-col gap-3 items-center justify-center pt-8 h-[200px] w-full bg-banner overflow-x-hidden">
      <div className="flex items-center gap-3 justify-center">
        <img src={serviceimg} alt="image of a service logo" />
        <h3 className="text-[#F0FFC5] font-semibold text-md">
          {header?.title || 'REVIEWS'}
        </h3>
      </div>
      <div>
        <h2 className="text-[#FFFF] text-3xl font-bold">
          {header?.subtitle || 'Testimonials'}
        </h2>
      </div>
    </section>
  );
};

export default Testimonials;
